import ControlModule from 'scripts/poppet/control-module';
import template      from './controlHeatingSwitchView.jst.html';
import { Vue }       from 'vue/defavue';
import { T }         from 'defa-object';

/**
 * defa.views.ControlSwitchesView
 * A control module for general home unit functionality.
 * @version 1.3.0
 */

const heatingSwitchOptions = [
	{ value: 'Home', title: T.tc('ControlGeneral', 'Home'), titleContext: 'ControlGeneral' },
	{ value: 'Away', title:T.tc('ControlGeneral', 'Away'), titleContext: 'ControlGeneral' },
	];


const ControlHeatingSwitchView = ControlModule.extend( {
	template : template,
	expandedNavState  : 'unit:control:switches',
	compressedNavState: 'unit:control:overview',

	className() {
		return this._getClassName( 'control-switches' );
	},

	onDomRefresh() {
		let self   = this;

		new Vue( {
			el: '#heating-slider',
			bb() {
				return {
					model: self.model,
				};
			},
			data() {
				return {
					heatingSwitchValue: 'Home',
					heatingSwitchOptions,
				};
			},
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= 'Home' === newValue;
					self.save( data )
				},
			},
			
			watch: {
				'model.heatingSwitch': function (newAttribute){
					this.heatingSwitchValue = newAttribute ? 'Home' : 'Away';
				}
			},
			
			created() {
				this.heatingSwitchValue = this.model.heatingSwitch ? 'Home' : 'Away';
			}
			
			
		});
	},
	save: function(attributes) {
		let self = this;
		self.model.set('isValidData', false);
		try {
			this.model.save(attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}

} );

export default ControlHeatingSwitchView;
